module.exports = __webpack_public_path__ + "static/media/google.0c182f86.svg";